import { gql, useMutation } from '@apollo/client'
import { userFollowsVar } from 'modulesCommon/store'

export const FOLLOW_PROJECT = gql`
  mutation ($campaign_id: String!) {
    followCampaign(campaign_id: $campaign_id) {
      id
      campaign_id
      user_id
    }
  }
`

export const useFollowProject = (campaignId: string) => {
  const [mutate, { data, error, loading }] = useMutation(FOLLOW_PROJECT, {
    variables: { campaign_id: campaignId },
    onCompleted: ({ followCampaign }) => {
      const currentFollows = userFollowsVar()
      userFollowsVar([...currentFollows, followCampaign])
    },
    update(cache) {
      cache.modify({
        fields: {
          getUserFollows() {}
        }
      })
    }
  })
  return { mutate, data, error, loading }
}
